import "./assets/styles/reset.scss";
import "./assets/styles/global.scss";
import ReactDOM from "react-dom/client";
import { setupStore } from "./store/store";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";

import "./i18n";
import index from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const store = setupStore();
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={index} />
    </QueryClientProvider>
  </Provider>
);
